module.exports = {
    "xspace.client.xform.XImage.xeditorUploadImageImage": "Upload Images",
    "xspace.client.xform.XImage.xeditorXImageAlign": "Align",
    "xspace.client.xform.XImage.xeditorXImageDeleteImage": "Delete Images",
    "xspace.client.xform.XImage.xeditorXImageDownloadImage": "Download Images",
    "xspace.client.xform.XImage.xeditorXImageImage": "Images",
    "xspace.client.xform.XImage.xeditorXImageLeftAlign": "Float to the Left",
    "xspace.client.xform.XImage.xeditorXImageNofloat": "Center",
    "xspace.client.xform.XImage.xeditorXImageReplaceImage": "Replace Images",
    "xspace.client.xform.XImage.xeditorXImageRestoreWidth": "Restore Original Size",
    "xspace.client.xform.XImage.xeditorXImageRightAlign": "Float to the Right",
    "xspace.client.xform.dateRange.xformDefaultEndDatePlaceholder": "End Date",
    "xspace.client.xform.dateRange.xformDefaultStartDatePlaceholder": "Start Date",
    "xspace.client.xform.index.xformDefaultSubmitButtonLabel": "Submit",
    "xspace.client.xform.index.xformUploaderErrorStatusCheckMessage": "You have images or files in upload error status, please submit after retry.",
    "xspace.client.xform.index.xformUploaderImageFileCheckMessage": "Upload is not a picture files, please re-upload pictures",
    "xspace.client.xform.index.xformUploaderUploadingStatusCheckMessage": "You have images or files in uploading status, please submit later.",
    "xspace.client.xform.insertbar.xeditorInsertbarMenuTitle": "Insert",
    "xspace.client.xform.insertbar.xeditorInsertbarTool": "Tools",
    "xspace.client.xform.multiSelect.xformCheckAllLabel": "Check All",
    "xspace.client.xform.upload.xformBatchUploadDefaultLabel": "Upload",
    "xspace.client.xform.upload.xformBatchUploadToolTip": "Press Ctrl/Command to batch upload files",
    "xspace.client.xform.upload.xformExampleImageLabel": "Example Image",
    "xspace.client.xform.upload.xformFileTemplateLabel": "Template",
    "xspace.client.xform.upload.xformMaxFileNumErrorTip": "The uploaded file exceeds the maximum limit",
    "xspace.client.xform.upload.xformMaxFileSizeErrorTip": "Max Upload File Size:",
    "xspace.client.xform.upload.xformUploadErrorTip": "Upload failed, please try again later."
};